import { IPreloadedState } from 'shared/types/redux';

export const selectIsAuthenticatedUser = (state: IPreloadedState) => state.user.isAuthenticated;
